import { BrowserProvider, getAddress } from "ethers";
import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

const CHAIN_ID = 77177;
const STATEMENT = "Sign in to FMI Smart Chain Hub. This is free and does not send a transaction.";

const buildMessage = (address, { nonce, issuedAt, expiresAt }) =>
  `${window.location.host} wants you to sign in with your Ethereum account:\n${address}\n\n${STATEMENT}\n\n` +
  `URI: ${window.location.origin}/account\nVersion: 1\nChain ID: ${CHAIN_ID}\nNonce: ${nonce}\nIssued At: ${issuedAt}\nExpiration Time: ${expiresAt}`;

export async function signInWithWallet(eip1193, address) {
  const checksum = getAddress(address);
  const nonce = await api.post("/wallet-auth/nonce", { address: checksum }).then((r) => r.data);
  const signer = await new BrowserProvider(eip1193).getSigner(checksum);
  const message = buildMessage(checksum, nonce);
  const signature = await signer.signMessage(message);
  return api.post("/wallet-auth/verify", { message, signature }, { withCredentials: true }).then((r) => r.data);
}

const fetchSession = () => api.get("/wallet-auth/me", { withCredentials: true }).then((r) => r.data).catch(() => null);

export function useWalletSession() {
  const qc = useQueryClient();
  const query = useQuery({ queryKey: ["walletSession"], queryFn: fetchSession, staleTime: 60000 });
  useEffect(() => {
    const onSession = () => qc.invalidateQueries({ queryKey: ["walletSession"] });
    window.addEventListener("fsc:wallet-session", onSession);
    return () => window.removeEventListener("fsc:wallet-session", onSession);
  }, [qc]);
  const refresh = () => qc.invalidateQueries({ queryKey: ["walletSession"] });
  const signOut = async () => {
    await api.post("/wallet-auth/logout", {}, { withCredentials: true });
    qc.setQueryData(["walletSession"], null);
  };
  return { session: query.data, loading: query.isLoading, refresh, signOut };
}
